// ES2017 w/ Node 5
require('core-js/fn/object/entries');
require('core-js/fn/object/values');
require('core-js/fn/object/get-own-property-descriptors');
require('core-js/fn/string/pad-start');
require('core-js/fn/string/pad-end');



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-preset-es2017/polyfill.js
 ** module id = 201
 ** module chunks = 0
 **/